import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

export default function CustomRadioGroup(props) {
    const { label, items, value, onChange, row } = props;

    return (
        <FormControl variant='outlined' component="fieldset">
            <FormLabel component="legend">{label}</FormLabel>
            <RadioGroup row={row} aria-label={label} name={`${label}_1`} value={value} onChange={onChange}>
                {items.map((item, index) => <FormControlLabel value={item.value} control={<Radio />} label={item.label} />)}
            </RadioGroup>
        </FormControl>
    );
}
